import { useEffect, useState } from "react";
import { getStatusChoices, StatusChoice } from "../api";

let cachedPromise: Promise<StatusChoice[]> | null = null;

function fetchOnce(): Promise<StatusChoice[]> {
	if (!cachedPromise) {
		cachedPromise = getStatusChoices();
	}
	return cachedPromise;
}

export function useStatusChoices(): StatusChoice[] {
	const [choices, setChoices] = useState<StatusChoice[]>([]);

	useEffect(() => {
		fetchOnce().then(setChoices);
	}, []);

	return choices;
}
